import { Star, BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";

const QUOTES = [
  {
    name: "Ananya Sharma", role: "MS Computer Science, USA", initials: "AS",
    quote: "Orion Edcon mapped my profile to the right universities and handled every detail of my visa file. I walked into my interview fully prepared — and walked out approved.",
  },
  {
    name: "Rohan Mehta", role: "M.Sc. Automotive Engineering, Germany", initials: "RM",
    quote: "Zero tuition at a top German public university felt impossible until their counsellors showed me the pathway. The blocked account and APS paperwork were handled flawlessly.",
  },
  {
    name: "Dr. K. Venkatesh", role: "Dean, Partner Institution — India", initials: "KV",
    quote: "Their advisory on twinning arrangements and regulatory compliance gave our board the confidence to sign our first international articulation agreement.",
  },
];

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="py-20 lg:py-28 bg-[#F8FAFC] border-t border-slate-900/10">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.18em] text-amber-800">05 — Success Stories</p>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B192C] mt-3 leading-[1.05] max-w-3xl">
          Trusted by <em className="italic text-amber-600">students</em> and institutions alike
        </h2>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {QUOTES.map((q, i) => (
          <Reveal key={q.name} delay={i * 0.1}>
            <figure data-testid={`testimonial-card-${i}`}
              className="h-full bg-white border border-slate-900/10 rounded-2xl p-7 flex flex-col hover:shadow-xl hover:shadow-slate-900/5 hover:-translate-y-1 transition-all duration-300">
              <span className="font-heading text-6xl leading-none text-amber-500/50 select-none">“</span>
              <blockquote className="font-heading text-lg sm:text-xl text-slate-800 leading-relaxed -mt-3 flex-1">{q.quote}</blockquote>
              <div className="flex gap-1 mt-5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-amber-500 text-amber-500" />
                ))}
              </div>
              <figcaption className="flex items-center gap-3 mt-4 pt-5 border-t border-slate-900/10">
                <span className="w-11 h-11 rounded-full bg-[#0B192C] text-amber-400 font-heading font-bold flex items-center justify-center ring-2 ring-amber-400/50">
                  {q.initials}
                </span>
                <div>
                  <p className="text-sm font-semibold text-[#0B192C]">{q.name}</p>
                  <p className="text-xs text-slate-500 flex items-center gap-1">
                    {q.role} <BadgeCheck className="w-3.5 h-3.5 text-amber-600" />
                  </p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
